export default __webpack_public_path__ + "static/media/dealerPolicy.08ad5dd1.png";